import { DataRequirements } from '../data.requirements';
import * as i0 from "@angular/core";
import * as i1 from "../data.requirements";
export class SetValleyPopupStatusUseCase {
    constructor(data) {
        this.data = data;
    }
    run(data) {
        return this.data.setValleyPopupStatus(data);
    }
}
SetValleyPopupStatusUseCase.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SetValleyPopupStatusUseCase_Factory() { return new SetValleyPopupStatusUseCase(i0.ɵɵinject(i1.DataRequirementsInjectionToken)); }, token: SetValleyPopupStatusUseCase, providedIn: "root" });
